export default "__VITE_ASSET__ECIlUGbp__"